import { env } from '@funny/env';
var OutsideMask = /** @class */ (function () {
    function OutsideMask() {
        this._root = null;
        this.insertCss();
        this.insertHtml();
        this.hide();
    }
    Object.defineProperty(OutsideMask.prototype, "maskRoot", {
        get: function () {
            // eslint-disable-next-line no-return-assign
            return this._root || (this._root = document.querySelector('#outside-mask-root'));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 关闭站外无法分享时候的引导分享弹窗
     * @returns
     */
    OutsideMask.prototype.hide = function () {
        if (!this.maskRoot) {
            return;
        }
        this.maskRoot.style.display = 'none';
    };
    /**
     * 打开站外无法分享时候的引导分享弹窗
     * @returns
     */
    OutsideMask.prototype.show = function () {
        if (!this.maskRoot) {
            return;
        }
        this.maskRoot.style.display = 'block';
    };
    /**
     * 插入站外引导分享弹窗的样式
     * @returns
     */
    OutsideMask.prototype.insertCss = function () {
        if (document.querySelector('#outside-mask-style')) {
            return;
        }
        var styleNode = document.createElement('style');
        styleNode.id = 'outside-mask-style';
        var styleRules = ".outside-share-bar__main-mask {\n      position: fixed;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 99999;\n      width: 100%;\n      height: 100%;\n      margin: auto;\n      background-color: rgba(0, 0, 0, 0.7);\n    }\n    .outside-share-bar__bubble-container {\n      position: relative;\n      width: 46.5%;\n      height: 80px;\n      margin: 42px auto 0;\n      color: #fff;\n      font-size: 14px;\n      line-height: 1.5;\n      background-color: #ff5046;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: center;\n      align-content: flex-start;\n      align-items: center;\n      text-align: center;\n      border-radius: 50%;\n    }\n    .outside-share-bar__step {\n      position: absolute;\n      top: 10px;\n      left: -5px;\n      width: 29px;\n      height: 29px;\n      color: #ff5046;\n      font-weight: 700;\n      line-height: 29px;\n      background-color: #fff;\n      text-align: center;\n      border-radius: 50%;\n    }\n    .outside-share-bar__step-img {\n      position: absolute;\n      top: -30px;\n      right: -50px;\n      width: 85px;\n    }\n    ";
        styleNode.innerHTML = styleRules;
        document.head.appendChild(styleNode);
    };
    /**
     * 插入站外引导分享的html
     * @returns
     */
    OutsideMask.prototype.insertHtml = function () {
        var _this = this;
        if (document.querySelector('#outside-mask-root')) {
            return;
        }
        var msg = env.browser.isAndroid ? '浏览器' : 'Safari';
        var maskRoot = document.createElement('div');
        maskRoot.id = 'outside-mask-root';
        maskRoot.classList.add('outside-share-bar__main-mask');
        var htmlSnippet = "<div class=\"outside-share-bar__bubble-container\">\n                          <div class=\"outside-share-bar__step\">1</div>\n                          \u70B9\u51FB\u9876\u680F<br>\n                          \u7684\u53F3\u4E0A\u89D2<img src=\"https://res.cdn.changbaimg.com/-/8d29e8f38a877472/right.png\" class=\"outside-share-bar__step-img\" alt=\"right img\" />\n                        </div>\n                        <div class=\"outside-share-bar__bubble-container\">\n                          <div class=\"outside-share-bar__step\">2</div>\n                          \u70B9\u51FB\u83DC\u5355\u4E2D\u7684<br>\n                          \u201C\u5728".concat(msg, "\u4E2D\u6253\u5F00\u201D\n                        </div>");
        maskRoot.innerHTML = htmlSnippet;
        maskRoot.addEventListener('click', function () {
            _this.hide();
        });
        document.body.appendChild(maskRoot);
    };
    return OutsideMask;
}());
export { OutsideMask };
